<template>
  <div class="column q-pa-md ">
    <div class="col-1 row q-gutter-md items-center" v-if="!isFetching">
      <div class="column">
        <h5 class="q-ma-xs">Выполнение задачи {{ performTask?.task.code }}</h5>
        <div class="q-ma-xs text-subtitle2">от {{ dayJs.utc(performTask?.executionTime).local().format("L") }}</div>
      </div>
    </div>
    <div class="col-1 row items-center" v-else>
      <q-skeleton type="QAvatar" />
      <div class="column ">
        <q-skeleton class="q-ma-xs" type="text" width="100px" />
        <q-skeleton class="q-ma-xs" type="text" width="20px" />
      </div>
    </div>
    <div class="col-10 row">
      <div class="col-12">
        <q-expansion-item switch-toggle-side expand-separator label="Детали">
          <div class="row  q-ma-md  items-center q-gutter-md">
            <div class="col-4">
              Количество фото:
              <span> {{ performTask?.uploadedPhoto }} / {{ performTask?.task.photoCount }}</span>
            </div>
            <div class="col-4">
              <span>Статус: </span>
              <q-chip :color="statusColors[performTask?.status]" text-color="white">{{
                status[performTask?.status]
              }}
              </q-chip>
            </div>
            <div class="col-4">
              <span>Состояние: </span>
              <q-chip :color="stateColors[performTask?.state]" text-color="white">{{
                states[performTask?.state]
              }}
              </q-chip>
            </div>
            <div class="col-4">
              <span>Дата выполнения: </span>
              <span v-if="performTask?.completedAt">{{ dayJs.utc(performTask?.completedAt).local().fromNow() }}</span>
              <span v-else>Еще не выполнена</span>
            </div>
          </div>
        </q-expansion-item>
      </div>
      <div class="col-12" v-if="performTask?.comment">
        <q-expansion-item switch-toggle-side expand-separator label="Комментарий">
          <div class="q-ma-md">
            {{ performTask?.comment }}
          </div>
        </q-expansion-item>
      </div>
      <div class="col-12" v-if="performTask?.photos.length > 0">
        <q-expansion-item switch-toggle-side expand-separator label="Фотографии">
          <div class="row q-gutter-md q-ma-md">
            <div class="col-12 col-md-2" v-for="photo in performTask?.photos.slice(0, 3)">
              <q-card>
                <q-img fit="cover" :ratio="16 / 9" v-ripple
                  :src="photoCaptionUrl(photo.address, photo.caption)" />
              </q-card>
            </div>
            <div class="col-12 col-md-2" :style="$q.screen.xs ? ({ minHeight: '150px' }) : {}">
              <q-card v-ripple @click="openPhotos = !openPhotos" class="bg-grey-4 fit text-center ">
                <q-icon name="more_horiz" color="white" class="absolute-center" size="60px" />
              </q-card>
            </div>
          </div>
        </q-expansion-item>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useProjectStore } from "../../store/project";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { status, statusColors, stateColors, states } from "../../util/state";
import { useReCaptcha } from 'vue-recaptcha-v3'
import { useRoute } from "vue-router";
import {
  useClosePerformTask,
  usePerformTask,
  usePerformTaskPhotoUpload,
  usePhotoUpload, useSharedPerformTask,
  useUploadToken
} from "../../composables/performTask";
import { useDayJs } from "../../composables/dayjs";
import Avatar from "../../components/Avatar.vue";
import { usePhotoStore } from "../../store/photo";
import { useAsyncState, useEventBus } from "@vueuse/core";
import { UploadRequest } from "../../models/performTask";
import { taskKey } from "../../util/events";
import { useRouteQuery } from "@vueuse/router";
import { photoCdnUrl } from "../../util/photoCdn";

const route = useRoute()
const dayJs = useDayJs()
const token = useRouteQuery('share')


const projectId = computed(() => Number(route.params.projectId))
const performTaskId = computed(() => Number(route.params.performTaskId))

const { data: performTask, isFetching, execute } = useSharedPerformTask(token)
const photoStore = usePhotoStore()
const { open: openPhotos, photos, shared } = storeToRefs(photoStore)
shared.value = true
watch(performTask, (val) => {
  photos.value = val?.photos
})

const photoCaptionUrl = (address: string, caption: string) => photoCdnUrl(address, {
  resize: 'x720',
  caption: { text: caption, fontSize: 16 },
  formatAfterCaption: 'jpeg',
})



</script>
